module.exports = __webpack_public_path__ + "img/func_3_2.b096bfe6.svg";